export const mediaUrl = (id: number) =>process.env.CROSS_API_URL + `/medias/${id}`